/**
 * * Libs
 *
 *
 */

/**
 * * Keen Slider
 */

!(function (n, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((n =
        "undefined" != typeof globalThis ? globalThis : n || self).KeenSlider =
        t());
})(this, function () {
  "use strict";
  var n = function () {
    return (
      (n =
        Object.assign ||
        function (n) {
          for (var t, i = 1, e = arguments.length; i < e; i++)
            for (var r in (t = arguments[i]))
              Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
          return n;
        }),
      n.apply(this, arguments)
    );
  };
  function t(n, t, i) {
    if (i || 2 === arguments.length)
      for (var e, r = 0, a = t.length; r < a; r++)
        (!e && r in t) ||
          (e || (e = Array.prototype.slice.call(t, 0, r)), (e[r] = t[r]));
    return n.concat(e || Array.prototype.slice.call(t));
  }
  function i(n) {
    return Array.prototype.slice.call(n);
  }
  function e(n, t) {
    var i = Math.floor(n);
    return i === t || i + 1 === t ? n : t;
  }
  function r() {
    return Date.now();
  }
  function a(n, t, i) {
    if (((t = "data-keen-slider-" + t), null === i))
      return n.removeAttribute(t);
    n.setAttribute(t, i || "");
  }
  function o(n, t) {
    return (
      (t = t || document),
      "function" == typeof n && (n = n(t)),
      Array.isArray(n)
        ? n
        : "string" == typeof n
        ? i(t.querySelectorAll(n))
        : n instanceof HTMLElement
        ? [n]
        : n instanceof NodeList
        ? i(n)
        : []
    );
  }
  function u(n) {
    n.raw && (n = n.raw),
      n.cancelable && !n.defaultPrevented && n.preventDefault();
  }
  function s(n) {
    n.raw && (n = n.raw), n.stopPropagation && n.stopPropagation();
  }
  function c() {
    var n = [];
    return {
      add: function (t, i, e, r) {
        t.addListener ? t.addListener(e) : t.addEventListener(i, e, r),
          n.push([t, i, e, r]);
      },
      input: function (n, t, i, e) {
        this.add(
          n,
          t,
          (function (n) {
            return function (t) {
              t.nativeEvent && (t = t.nativeEvent);
              var i = t.changedTouches || [],
                e = t.targetTouches || [],
                r = t.detail && t.detail.x ? t.detail : null;
              return n({
                id: r
                  ? r.identifier
                    ? r.identifier
                    : "i"
                  : e[0]
                  ? e[0]
                    ? e[0].identifier
                    : "e"
                  : "d",
                idChanged: r
                  ? r.identifier
                    ? r.identifier
                    : "i"
                  : i[0]
                  ? i[0]
                    ? i[0].identifier
                    : "e"
                  : "d",
                raw: t,
                x: r && r.x ? r.x : e[0] ? e[0].screenX : r ? r.x : t.pageX,
                y: r && r.y ? r.y : e[0] ? e[0].screenY : r ? r.y : t.pageY,
              });
            };
          })(i),
          e
        );
      },
      purge: function () {
        n.forEach(function (n) {
          n[0].removeListener
            ? n[0].removeListener(n[2])
            : n[0].removeEventListener(n[1], n[2], n[3]);
        }),
          (n = []);
      },
    };
  }
  function d(n, t, i) {
    return Math.min(Math.max(n, t), i);
  }
  function l(n) {
    return (n > 0 ? 1 : 0) - (n < 0 ? 1 : 0) || +n;
  }
  function f(n) {
    var t = n.getBoundingClientRect();
    return {
      height: e(t.height, n.offsetHeight),
      width: e(t.width, n.offsetWidth),
    };
  }
  function p(n, t, i, e) {
    var r = n && n[t];
    return null == r ? i : e && "function" == typeof r ? r() : r;
  }
  function v(n) {
    return Math.round(1e6 * n) / 1e6;
  }
  function h(n) {
    var t, i, e, r, a, o;
    function u(t) {
      o || (o = t), s(!0);
      var a = t - o;
      a > e && (a = e);
      var l = r[i];
      if (l[3] < a) return i++, u(t);
      var f = l[2],
        p = l[4],
        v = l[0],
        h = l[1] * (0, l[5])(0 === p ? 1 : (a - f) / p);
      if ((h && n.track.to(v + h), a < e)) return d();
      (o = null), s(!1), c(null), n.emit("animationEnded");
    }
    function s(n) {
      t.active = n;
    }
    function c(n) {
      t.targetIdx = n;
    }
    function d() {
      var n;
      (n = u), (a = window.requestAnimationFrame(n));
    }
    function l() {
      var t;
      (t = a),
        window.cancelAnimationFrame(t),
        s(!1),
        c(null),
        o && n.emit("animationStopped"),
        (o = null);
    }
    return (t = {
      active: !1,
      start: function (t) {
        if ((l(), n.track.details)) {
          var a = 0,
            o = n.track.details.position;
          (i = 0),
            (e = 0),
            (r = t.map(function (n) {
              var t,
                i = o,
                r = null !== (t = n.earlyExit) && void 0 !== t ? t : n.duration,
                u = n.easing,
                s = n.distance * u(r / n.duration) || 0;
              o += s;
              var c = e;
              return (e += r), (a += s), [i, n.distance, c, e, n.duration, u];
            })),
            c(n.track.distToIdx(a)),
            d(),
            n.emit("animationStarted");
        }
      },
      stop: l,
      targetIdx: null,
    });
  }
  function m(n) {
    var i,
      e,
      a,
      o,
      u,
      s,
      c,
      f,
      h,
      m,
      g,
      b,
      x,
      y,
      k = 1 / 0,
      w = [],
      M = null,
      T = 0;
    function C(n) {
      _(T + n);
    }
    function E(n) {
      var t = z(T + n).abs;
      return D(t) ? t : null;
    }
    function z(n) {
      var i = Math.floor(Math.abs(v(n / e))),
        r = v(((n % e) + e) % e);
      r === e && (r = 0);
      var a = l(n),
        o = c.indexOf(
          t([], c, !0).reduce(function (n, t) {
            return Math.abs(t - r) < Math.abs(n - r) ? t : n;
          })
        ),
        u = o;
      return (
        a < 0 && i++,
        o === s && ((u = 0), (i += a > 0 ? 1 : -1)),
        { abs: u + i * s * a, origin: o, rel: u }
      );
    }
    function I(n, t, i) {
      var e;
      if (t || !S()) return A(n, i);
      if (!D(n)) return null;
      var r = z(null != i ? i : T),
        a = r.abs,
        o = n - r.rel,
        u = a + o;
      e = A(u);
      var c = A(u - s * l(o));
      return (
        ((null !== c && Math.abs(c) < Math.abs(e)) || null === e) && (e = c),
        v(e)
      );
    }
    function A(n, t) {
      if ((null == t && (t = v(T)), !D(n) || null === n)) return null;
      n = Math.round(n);
      var i = z(t),
        r = i.abs,
        a = i.rel,
        o = i.origin,
        u = O(n),
        d = ((t % e) + e) % e,
        l = c[o],
        f = Math.floor((n - (r - a)) / s) * e;
      return v(l - d - l + c[u] + f + (o === s ? e : 0));
    }
    function D(n) {
      return L(n) === n;
    }
    function L(n) {
      return d(n, h, m);
    }
    function S() {
      return o.loop;
    }
    function O(n) {
      return ((n % s) + s) % s;
    }
    function _(t) {
      var i;
      (i = t - T),
        w.push({ distance: i, timestamp: r() }),
        w.length > 6 && (w = w.slice(-6)),
        (T = v(t));
      var e = H().abs;
      if (e !== M) {
        var a = null !== M;
        (M = e), a && n.emit("slideChanged");
      }
    }
    function H(t) {
      var r = t
        ? null
        : (function () {
            if (s) {
              var n = S(),
                t = n ? ((T % e) + e) % e : T,
                i = (n ? T % e : T) - u[0][2],
                r = 0 - (i < 0 && n ? e - Math.abs(i) : i),
                c = 0,
                d = z(T),
                f = d.abs,
                p = d.rel,
                v = u[p][2],
                k = u.map(function (t, i) {
                  var a = r + c;
                  (a < 0 - t[0] || a > 1) &&
                    (a += (Math.abs(a) > e - 1 && n ? e : 0) * l(-a));
                  var u = i - p,
                    d = l(u),
                    h = u + f;
                  n &&
                    (-1 === d && a > v && (h += s),
                    1 === d && a < v && (h -= s),
                    null !== g && h < g && (a += e),
                    null !== b && h > b && (a -= e));
                  var m = a + t[0] + t[1],
                    x = Math.max(
                      a >= 0 && m <= 1
                        ? 1
                        : m < 0 || a > 1
                        ? 0
                        : a < 0
                        ? Math.min(1, (t[0] + a) / t[0])
                        : (1 - a) / t[0],
                      0
                    );
                  return (
                    (c += t[0] + t[1]),
                    {
                      abs: h,
                      distance: o.rtl ? -1 * a + 1 - t[0] : a,
                      portion: x,
                      size: t[0],
                    }
                  );
                });
              return (
                (f = L(f)),
                (p = O(f)),
                {
                  abs: L(f),
                  length: a,
                  max: y,
                  maxIdx: m,
                  min: x,
                  minIdx: h,
                  position: T,
                  progress: n ? t / e : T / a,
                  rel: p,
                  slides: k,
                  slidesLength: e,
                }
              );
            }
          })();
      return (i.details = r), n.emit("detailsChanged"), r;
    }
    return (i = {
      absToRel: O,
      add: C,
      details: null,
      distToIdx: E,
      idxToDist: I,
      init: function (t) {
        if (
          ((function () {
            if (
              ((o = n.options),
              (u = (o.trackConfig || []).map(function (n) {
                return [p(n, "size", 1), p(n, "spacing", 0), p(n, "origin", 0)];
              })),
              (s = u.length))
            ) {
              e = v(
                u.reduce(function (n, t) {
                  return n + t[0] + t[1];
                }, 0)
              );
              var t,
                i = s - 1;
              (a = v(e + u[0][2] - u[i][0] - u[i][2] - u[i][1])),
                (c = u.reduce(function (n, i) {
                  if (!n) return [0];
                  var e = u[n.length - 1],
                    r = n[n.length - 1] + (e[0] + e[2]) + e[1];
                  return (
                    (r -= i[2]),
                    n[n.length - 1] > r && (r = n[n.length - 1]),
                    (r = v(r)),
                    n.push(r),
                    (!t || t < r) && (f = n.length - 1),
                    (t = r),
                    n
                  );
                }, null)),
                0 === a && (f = 0),
                c.push(v(e));
            }
          })(),
          !s)
        )
          return H(!0);
        var i;
        !(function () {
          var t = n.options.range,
            i = n.options.loop;
          (g = h = i ? p(i, "min", -1 / 0) : 0),
            (b = m = i ? p(i, "max", k) : f);
          var e = p(t, "min", null),
            r = p(t, "max", null);
          e && (h = e),
            r && (m = r),
            (x = h === -1 / 0 ? h : n.track.idxToDist(h || 0, !0, 0)),
            (y = m === k ? m : I(m, !0, 0)),
            null === r && (b = m),
            p(t, "align", !1) &&
              m !== k &&
              0 === u[O(m)][2] &&
              ((y -= 1 - u[O(m)][0]), (m = E(y - T))),
            (x = v(x)),
            (y = v(y));
        })(),
          (i = t),
          Number(i) === i ? C(A(L(t))) : H();
      },
      to: _,
      velocity: function () {
        var n = r(),
          t = w.reduce(
            function (t, i) {
              var e = i.distance,
                r = i.timestamp;
              return (
                n - r > 200 ||
                  (l(e) !== l(t.distance) &&
                    t.distance &&
                    (t = { distance: 0, lastTimestamp: 0, time: 0 }),
                  t.time && (t.distance += e),
                  t.lastTimestamp && (t.time += r - t.lastTimestamp),
                  (t.lastTimestamp = r)),
                t
              );
            },
            { distance: 0, lastTimestamp: 0, time: 0 }
          );
        return t.distance / t.time || 0;
      },
    });
  }
  function g(n) {
    var t, i, e, r, a, o, u;
    function s(n) {
      return 2 * n;
    }
    function c(n) {
      return d(n, o, u);
    }
    function f(n) {
      return 1 - Math.pow(1 - n, 3);
    }
    function p() {
      m();
      var t = "free-snap" === n.options.mode,
        i = n.track,
        o = i.velocity();
      e = l(o);
      var u = n.track.details,
        d = [];
      if (o || !t) {
        var p = v(o),
          h = p.dist,
          g = p.dur;
        if (((g = s(g)), (h *= e), t)) {
          var b = i.idxToDist(i.distToIdx(h), !0);
          b && (h = b);
        }
        d.push({ distance: h, duration: g, easing: f });
        var x = u.position,
          y = x + h;
        if (y < r || y > a) {
          var k = y < r ? r - x : a - x,
            w = 0,
            M = o;
          if (l(k) === e) {
            var T = Math.min(Math.abs(k) / Math.abs(h), 1),
              C =
                (function (n) {
                  return 1 - Math.pow(1 - n, 1 / 3);
                })(T) * g;
            (d[0].earlyExit = C), (M = o * (1 - T));
          } else (d[0].earlyExit = 0), (w += k);
          var E = v(M, 100),
            z = E.dist * e;
          n.options.rubberband &&
            (d.push({ distance: z, duration: s(E.dur), easing: f }),
            d.push({ distance: -z + w, duration: 500, easing: f }));
        }
        n.animator.start(d);
      } else
        n.moveToIdx(c(u.abs), !0, {
          duration: 500,
          easing: function (n) {
            return 1 + --n * n * n * n * n;
          },
        });
    }
    function v(n, t) {
      void 0 === t && (t = 1e3);
      var i = 147e-9 + (n = Math.abs(n)) / t;
      return { dist: Math.pow(n, 2) / i, dur: n / i };
    }
    function h() {
      var t = n.track.details;
      t && ((r = t.min), (a = t.max), (o = t.minIdx), (u = t.maxIdx));
    }
    function m() {
      n.animator.stop();
    }
    n.on("updated", h),
      n.on("optionsChanged", h),
      n.on("created", h),
      n.on("dragStarted", function () {
        m(), (t = i = n.track.details.abs);
      }),
      n.on("dragEnded", function () {
        var e = n.options.mode;
        "snap" === e &&
          (function () {
            var e = n.track,
              o = n.track.details,
              u = o.position,
              s = l(e.velocity());
            (u > a || u < r) && (s = 0);
            var d = t + s;
            0 === o.slides[e.absToRel(d)].portion && (d -= s),
              t !== i && (d = i),
              l(e.idxToDist(d, !0)) !== s && (d += s),
              (d = c(d));
            var f = e.idxToDist(d, !0);
            n.animator.start([
              {
                distance: f,
                duration: 500,
                easing: function (n) {
                  return 1 + --n * n * n * n * n;
                },
              },
            ]);
          })(),
          ("free" !== e && "free-snap" !== e) || p();
      }),
      n.on("dragged", function () {
        i = n.track.details.abs;
      });
  }
  function b(n) {
    var t,
      i,
      e,
      r,
      a,
      f,
      p,
      v,
      h,
      m,
      g,
      b,
      x,
      y,
      k,
      w,
      M,
      T,
      C = c();
    function E(t) {
      if (f && v === t.id) {
        var o = D(t);
        if (h) {
          if (!A(t)) return I(t);
          (m = o), (h = !1), n.emit("dragChecked");
        }
        if (w) return (m = o);
        u(t);
        var c = (function (t) {
          if (M === -1 / 0 && T === 1 / 0) return t;
          var e = n.track.details,
            o = e.length,
            u = e.position,
            s = d(t, M - u, T - u);
          if (0 === o) return 0;
          if (!n.options.rubberband) return s;
          if (u <= T && u >= M) return t;
          if ((u < M && i > 0) || (u > T && i < 0)) return t;
          var c = (u < M ? u - M : u - T) / o,
            l = r * o,
            f = Math.abs(c * l),
            p = Math.max(0, 1 - (f / a) * 2);
          return p * p * t;
        })((p(m - o) / r) * e);
        i = l(c);
        var x = n.track.details.position;
        ((x > M && x < T) || (x === M && i > 0) || (x === T && i < 0)) && s(t),
          (g += c),
          !b && Math.abs(g * r) > 5 && (b = !0),
          n.track.add(c),
          (m = o),
          n.emit("dragged");
      }
    }
    function z(t) {
      !f &&
        n.track.details &&
        n.track.details.length &&
        ((g = 0),
        (f = !0),
        (b = !1),
        (h = !0),
        (v = t.id),
        A(t),
        (m = D(t)),
        n.emit("dragStarted"));
    }
    function I(t) {
      f && v === t.idChanged && ((f = !1), n.emit("dragEnded"));
    }
    function A(n) {
      var t = L(),
        i = t ? n.y : n.x,
        e = t ? n.x : n.y,
        r = void 0 !== x && void 0 !== y && Math.abs(y - e) <= Math.abs(x - i);
      return (x = i), (y = e), r;
    }
    function D(n) {
      return L() ? n.y : n.x;
    }
    function L() {
      return n.options.vertical;
    }
    function S() {
      (r = n.size), (a = L() ? window.innerHeight : window.innerWidth);
      var t = n.track.details;
      t && ((M = t.min), (T = t.max));
    }
    function O(n) {
      b && (s(n), u(n));
    }
    function _() {
      if ((C.purge(), n.options.drag && !n.options.disabled)) {
        var i;
        (i = n.options.dragSpeed || 1),
          (p =
            "function" == typeof i
              ? i
              : function (n) {
                  return n * i;
                }),
          (e = n.options.rtl ? -1 : 1),
          S(),
          (t = n.container),
          (function () {
            var n = "data-keen-slider-clickable";
            o("[".concat(n, "]:not([").concat(n, "=false])"), t).map(function (
              n
            ) {
              C.add(n, "mousedown", s), C.add(n, "touchstart", s);
            });
          })(),
          C.add(t, "dragstart", function (n) {
            u(n);
          }),
          C.add(t, "click", O, { capture: !0 }),
          C.input(t, "ksDragStart", z),
          C.input(t, "ksDrag", E),
          C.input(t, "ksDragEnd", I),
          C.input(t, "mousedown", z),
          C.input(t, "mousemove", E),
          C.input(t, "mouseleave", I),
          C.input(t, "mouseup", I),
          C.input(t, "touchstart", z, { passive: !0 }),
          C.input(t, "touchmove", E, { passive: !1 }),
          C.input(t, "touchend", I),
          C.input(t, "touchcancel", I),
          C.add(window, "wheel", function (n) {
            f && u(n);
          });
        var r = "data-keen-slider-scrollable";
        o("[".concat(r, "]:not([").concat(r, "=false])"), n.container).map(
          function (n) {
            return (function (n) {
              var t;
              C.input(
                n,
                "touchstart",
                function (n) {
                  (t = D(n)), (w = !0), (k = !0);
                },
                { passive: !0 }
              ),
                C.input(n, "touchmove", function (i) {
                  var e = L(),
                    r = e
                      ? n.scrollHeight - n.clientHeight
                      : n.scrollWidth - n.clientWidth,
                    a = t - D(i),
                    o = e ? n.scrollTop : n.scrollLeft,
                    s =
                      (e && "scroll" === n.style.overflowY) ||
                      (!e && "scroll" === n.style.overflowX);
                  if (
                    ((t = D(i)),
                    ((a < 0 && o > 0) || (a > 0 && o < r)) && k && s)
                  )
                    return (w = !0);
                  (k = !1), u(i), (w = !1);
                }),
                C.input(n, "touchend", function () {
                  w = !1;
                });
            })(n);
          }
        );
      }
    }
    n.on("updated", S),
      n.on("optionsChanged", _),
      n.on("created", _),
      n.on("destroyed", C.purge);
  }
  function x(n) {
    var t,
      i,
      e = null;
    function r(t, i, e) {
      n.animator.active
        ? o(t, i, e)
        : requestAnimationFrame(function () {
            return o(t, i, e);
          });
    }
    function a() {
      r(!1, !1, i);
    }
    function o(i, r, a) {
      var o = 0,
        u = n.size,
        d = n.track.details;
      if (d && t) {
        var l = d.slides;
        t.forEach(function (n, t) {
          if (i) !e && r && s(n, null, a), c(n, null, a);
          else {
            if (!l[t]) return;
            var d = l[t].size * u;
            !e && r && s(n, d, a), c(n, l[t].distance * u - o, a), (o += d);
          }
        });
      }
    }
    function u(t) {
      return "performance" === n.options.renderMode ? Math.round(t) : t;
    }
    function s(n, t, i) {
      var e = i ? "height" : "width";
      null !== t && (t = u(t) + "px"),
        (n.style["min-" + e] = t),
        (n.style["max-" + e] = t);
    }
    function c(n, t, i) {
      if (null !== t) {
        t = u(t);
        var e = i ? t : 0;
        t = "translate3d(".concat(i ? 0 : t, "px, ").concat(e, "px, 0)");
      }
      (n.style.transform = t), (n.style["-webkit-transform"] = t);
    }
    function d() {
      t && (o(!0, !0, i), (t = null)), n.on("detailsChanged", a, !0);
    }
    function l() {
      r(!1, !0, i);
    }
    function f() {
      d(),
        (i = n.options.vertical),
        n.options.disabled ||
          "custom" === n.options.renderMode ||
          ((e = "auto" === p(n.options.slides, "perView", null)),
          n.on("detailsChanged", a),
          (t = n.slides).length && l());
    }
    n.on("created", f),
      n.on("optionsChanged", f),
      n.on("beforeOptionsChanged", function () {
        d();
      }),
      n.on("updated", l),
      n.on("destroyed", d);
  }
  function y(t, i) {
    return function (e) {
      var r,
        u,
        s,
        d,
        l,
        v,
        h = c();
      function m(n) {
        var t;
        a(
          e.container,
          "reverse",
          "rtl" !==
            ((t = e.container),
            window.getComputedStyle(t, null).getPropertyValue("direction")) || n
            ? null
            : ""
        ),
          a(e.container, "v", e.options.vertical && !n ? "" : null),
          a(e.container, "disabled", e.options.disabled && !n ? "" : null);
      }
      function g() {
        b() && M();
      }
      function b() {
        var t = null;
        if (
          (d.forEach(function (n) {
            n.matches && (t = n.__media);
          }),
          t === r)
        )
          return !1;
        r || e.emit("beforeOptionsChanged"), (r = t);
        var i = t ? s.breakpoints[t] : s;
        return (e.options = n(n({}, s), i)), m(), I(), A(), C(), !0;
      }
      function x(n) {
        var t = f(n);
        return (e.options.vertical ? t.height : t.width) / e.size || 1;
      }
      function y() {
        return e.options.trackConfig.length;
      }
      function k(t) {
        for (var a in ((r = !1),
        (s = n(n({}, i), t)),
        h.purge(),
        (u = e.size),
        (d = []),
        s.breakpoints || [])) {
          var o = window.matchMedia(a);
          (o.__media = a), d.push(o), h.add(o, "change", g);
        }
        h.add(window, "orientationchange", z), h.add(window, "resize", E), b();
      }
      function w(n) {
        e.animator.stop();
        var t = e.track.details;
        e.track.init(null != n ? n : t ? t.abs : 0);
      }
      function M(n) {
        w(n), e.emit("optionsChanged");
      }
      function T(n, t) {
        if (n) return k(n), void M(t);
        I(), A();
        var i = y();
        C(), y() !== i ? M(t) : w(t), e.emit("updated");
      }
      function C() {
        var n = e.options.slides;
        if ("function" == typeof n)
          return (e.options.trackConfig = n(e.size, e.slides));
        for (
          var t = e.slides,
            i = t.length,
            r = "number" == typeof n ? n : p(n, "number", i, !0),
            a = [],
            o = p(n, "perView", 1, !0),
            u = p(n, "spacing", 0, !0) / e.size || 0,
            s = "auto" === o ? u : u / o,
            c = p(n, "origin", "auto"),
            d = 0,
            l = 0;
          l < r;
          l++
        ) {
          var f = "auto" === o ? x(t[l]) : 1 / o - u + s,
            v = "center" === c ? 0.5 - f / 2 : "auto" === c ? 0 : c;
          a.push({ origin: v, size: f, spacing: u }), (d += f);
        }
        if (((d += u * (r - 1)), "auto" === c && !e.options.loop && 1 !== o)) {
          var h = 0;
          a.map(function (n) {
            var t = d - h;
            return (
              (h += n.size + u),
              t >= 1 || (n.origin = 1 - t - (d > 1 ? 0 : 1 - d)),
              n
            );
          });
        }
        e.options.trackConfig = a;
      }
      function E() {
        I();
        var n = e.size;
        e.options.disabled || n === u || ((u = n), T());
      }
      function z() {
        E(), setTimeout(E, 500), setTimeout(E, 2e3);
      }
      function I() {
        var n = f(e.container);
        e.size = (e.options.vertical ? n.height : n.width) || 1;
      }
      function A() {
        e.slides = o(e.options.selector, e.container);
      }
      (e.container = (v = o(t, l || document)).length ? v[0] : null),
        (e.destroy = function () {
          h.purge(), e.emit("destroyed"), m(!0);
        }),
        (e.prev = function () {
          e.moveToIdx(e.track.details.abs - 1, !0);
        }),
        (e.next = function () {
          e.moveToIdx(e.track.details.abs + 1, !0);
        }),
        (e.update = T),
        k(e.options);
    };
  }
  return function (n, i, e) {
    try {
      return (function (n, t) {
        var i,
          e = {};
        return (
          (i = {
            emit: function (n) {
              e[n] &&
                e[n].forEach(function (n) {
                  n(i);
                });
              var t = i.options && i.options[n];
              t && t(i);
            },
            moveToIdx: function (n, t, e) {
              var r = i.track.idxToDist(n, t);
              if (r) {
                var a = i.options.defaultAnimation;
                i.animator.start([
                  {
                    distance: r,
                    duration: p(e || a, "duration", 500),
                    easing: p(e || a, "easing", function (n) {
                      return 1 + --n * n * n * n * n;
                    }),
                  },
                ]);
              }
            },
            on: function (n, t, i) {
              void 0 === i && (i = !1), e[n] || (e[n] = []);
              var r = e[n].indexOf(t);
              r > -1 ? i && delete e[n][r] : i || e[n].push(t);
            },
            options: n,
          }),
          (function () {
            if (((i.track = m(i)), (i.animator = h(i)), t))
              for (var n = 0, e = t; n < e.length; n++) (0, e[n])(i);
            i.track.init(i.options.initial || 0), i.emit("created");
          })(),
          i
        );
      })(
        i,
        t(
          [
            y(n, {
              drag: !0,
              mode: "snap",
              renderMode: "precision",
              rubberband: !0,
              selector: ".keen-slider__slide",
            }),
            x,
            b,
            g,
          ],
          e || [],
          !0
        )
      );
    } catch (n) {
      console.error(n);
    }
  };
});

/**
 * * Keen slider navigaiotn
 */

function navigation(slider) {
  let wrapper, dots, arrowLeft, arrowRight;

  function markup(remove) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createDiv("arrow arrow--left");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowRight = createDiv("arrow arrow--right");
    arrowRight.addEventListener("click", () => slider.next());

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("navigation-wrapper");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function dotMarkup(remove) {
    if (remove) {
      removeElement(dots);
      return;
    }
    dots = createDiv("dots");
    slider.track.details.slides.forEach((_e, idx) => {
      var dot = createDiv("dot");
      dot.addEventListener("click", () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    });
    wrapper.appendChild(dots);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    console.log(2);
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });
}

/**
 * * Helper functions
 *
 *
 *
 *
 */
function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      detail: data,
    })
  );
}
function triggerNonBubblingEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: false,
      detail: data,
    })
  );
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (
      domElement.hasAttribute("section") &&
      domElement.getAttribute("section") === event.detail.sectionId
    ) {
      executeCallback = true;
    }
  } else if (
    event.type.includes("shopify:block") &&
    event.target === domElement
  ) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/**
 * * Product Grid Animation
 */

/**
 * * Intersection Observer
 */

const options = {
  threshold: 0,
  rootMargin: "30px 0px",
};

const inViewCallback = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("inview");
      // entry.target.style.opacity = "1";
    } else {
      // OPTIONAL, in case you want to do something once the intersection is done
    }
  });
};

let observer = new IntersectionObserver(inViewCallback, options);

/**
 ** Shopify Common JS
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    console.log("selecotr", selector);
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/**
 * * UI elements
 *
 *
 *
 *
 *
 */

/**
 *
 * * Drawers / modals
 *
 *
 */
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  // if (summary.closest('header-drawer')) return;
  // summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

/**
 * *Store Header
 *
 */
class StoreHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.header = document.getElementById('shopify-section-header');
    this.header = this;
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    // this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollHandler, false);
    this.createObserver();

    // this.logo = this.querySelector(".logo")
    // this.logo.addEventListener("mouseEnter")
  }

  logoHover() {}

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = document.documentElement.scrollTop;
    // if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // console.log("headerBounds", this.headerBounds)
    if (scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      requestAnimationFrame(this.fillColor.bind(this));
    } else {
      requestAnimationFrame(this.removeFillColor.bind(this));
    }
  }

  fillColor() {
    this.header.classList.add("is-filled");
  }

  removeFillColor() {
    this.header.classList.remove("is-filled");
  }
}

window.customElements.define("store-header", StoreHeader);

/**
 * * Product Form
 * * Includes:
 * * ProductVariants, ProductForm, QuantityInput
 *
 *
 */

/**
 * * Variant Selects
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
    console.log("updateOptions", this.options);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    console.log("updatemaster", this.currentVariant);
  }

  // updateMedia() {
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;

  //   const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
  //   mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

  //   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
  //   if (!modalContent) return;
  //   const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
  //   modalContent.prepend(newMediaModal);
  // }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("sr-only");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.themeVariables.strings.soldOut
        );
      });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.themeVariables.strings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("sr-only");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

window.customElements.define("variant-selects", VariantSelects);

/**
 * * Variant Radios
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

window.customElements.define("variant-radios", VariantRadios);

/**
 * * ProductVariants
 * ! Depreciated
 */
// class ProductVariants extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener('change', this.onVariantChange);
//   }

//   onVariantChange() {
//     // alert("change")
//     this.updateOptions();
//     this.updateMasterId();
//     this.toggleAddButton(true, '', false);
//     // this.updatePickupAvailability();
//     // this.removeErrorMessage();

//     if (!this.currentVariant) {
//       this.toggleAddButton(true, '', true);
//       this.setUnavailable();
//     } else {
//       // this.updateMedia();
//       this.updateURL();
//       this.updateVariantInput();
//       this.renderProductInfo();
//       // this.updateShareUrl();
//     }
//   }

//   updateOptions() {
//     this.options = Array.from(
//       this.querySelectorAll('select'),
//       (select) => select.value,
//     );

//     // console.log(this.options)
//   }

//   updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//     window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }

//   updateVariantInput() {
//     const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
//     // console.log("this.dataset.section", this.dataset.section)
//     productForms.forEach((productForm) => {
//       const input = productForm.querySelector('input[name="id"]');
//       input.value = this.currentVariant.id;
//       const change = input.dispatchEvent(new Event('change', { bubbles: true }));

//     });
//   }

//   updateMasterId() {
//     this.currentVariant = this.getVariantData().find((variant) => {
//       return !variant.options
//         .map((option, index) => {
//           return this.options[index] === option;
//         })
//         .includes(false);
//     });

//     console.log("currentVariant", this.currentVariant)
//   }

//   getVariantData() {
//     this.variantData =
//       this.variantData ||
//       JSON.parse(this.querySelector('[type="application/json"]').textContent);

//     console.log("variantData", this.variantData)
//     return this.variantData;
//   }

//   renderProductInfo() {
//     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
//       .then((response) => response.text())
//       .then((responseText) => {
//         const html = new DOMParser().parseFromString(responseText, 'text/html')
//         const destination = document.getElementById(`price-${this.dataset.section}`);
//         console.log("destination", destination)

//         const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
//         console.log("source", source)

//         if (source && destination) destination.innerHTML = source.innerHTML;

//         const price = document.getElementById(`price-${this.dataset.section}`);
//         if (price) price.classList.remove('sr-only');
//         this.toggleAddButton(!this.currentVariant.available, window.themeVariables.strings.soldOut);
//       })

//   }

//   setUnavailable() {
//     const button = document.getElementById(
//       `product-form-${this.dataset.section}`,
//     );
//     console.log("button", button)
//     const addButton = button.querySelector('[name="add"]');
//     const addButtonText = button.querySelector('[name="add"] > span');
//     const price = document.getElementById(`price-${this.dataset.section}`);
//     if (!addButton) return;
//     addButtonText.textContent = window.themeVariables.strings.unavailable;
//     if (price) price.classList.add('invisible');
//   }

//   toggleAddButton(disable = true, text, modifyClass = true) {
//     const productForm = document.getElementById(this.getAttribute("form-id"));
//     console.log("productForm", productForm)

//     if (!productForm) return;
//     const addButton = productForm.querySelector('[name="add"]');
//     const addButtonText = productForm.querySelector('[name="add"] > span');

//     console.log("addButton", addButton)
//     console.log("addButtonText", addButtonText)

//     if (!addButton) return;

//     if (disable) {
//       addButton.setAttribute('disabled', 'disabled');
//       if (text) addButtonText.textContent = text;
//     } else {
//       addButton.removeAttribute('disabled');
//       addButtonText.textContent = window.themeVariables.strings.addToCart;
//     }

//     if (!modifyClass) return;
//   }

//   connectedCallback() {
//     //implementation
//   }

//   disconnectedCallback() {
//     //implementation
//   }

//   attributeChangedCallback(name, oldVal, newVal) {
//     //implementation
//   }

//   adoptedCallback() {
//     //implementation
//   }

// }
// window.customElements.define('product-variants', ProductVariants);

/**
 * * ProductForm
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    // if (document.querySelector("cart-drawer"))
    //   this.submitButton.setAttribute("aria-haspopup", "dialog");
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    // this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("is-loading");
    this.querySelector(".loader-spinner").classList.remove("hidden");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${themeVariables.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        console.log("response", response);
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;

          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.themeVariables.routes.cart_url;
          return;
        }

        this.error = false;

        const quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          // document.body.addEventListener('modalClosed', () => {
          //   setTimeout(() => { this.cart.renderContents(response) });
          // }, { once: true });
          // quickAddModal.hide(true);
        } else {
          // cart notification
          this.cart.renderContents(response);
          console.log("this,cart res", response);
        }
      })
      .catch((e) => console.error("ProductForm E", e))
      .finally((e) => {
        this.submitButton.classList.remove("is-loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loader-spinner").classList.add("hidden");
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".product-form__error-message");

    // this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    this.errorMessageWrapper.classList.toggle("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

window.customElements.define("product-form", ProductForm);

/**
 * * QuantityInput
 *
 *
 *
 *
 */
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    // event.target.name === 'plus' ? console.log("+") : console.log("-")
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

window.customElements.define("quantity-input", QuantityInput);

/**
 * * Cart Remove
 */
class CartRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
      console.log("cartItems", cartItems);
      console.log("this.dataset.index, 0", this.dataset.index, 0);
    });
  }
}

window.customElements.define("cart-remove", CartRemove);

/**
 * * Cart Items
 *
 */
class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "main-cart-summary",
        section: document.getElementById("main-cart-summary").dataset.id,
        selector: ".js-cart-summary",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      // {
      //   id: 'main-cart-summary',
      //   section: `main-cart-summary-${document.getElementById('main-cart-items').dataset.id}`,
      //   // section: 'cart-summary',
      //   selector: '.js-cart-summary'
      // },
    ];
  }

  updateQuantity(line, quantity, name) {
    // this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${themeVariables.routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log("parsedState", parsedState);

        this.classList.toggle("is-empty", parsedState.item_count === 0);

        const cartSummary = document.getElementById("main-cart-summary");
        console.log("cartSummary", cartSummary);
        if (cartSummary)
          cartSummary.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        const cartLayout = document.getElementById("main-cart-layout");
        if (cartLayout)
          cartLayout.classList.toggle("is-empty", parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          // console.log("section", section)

          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          // console.log("elementToReplace", elementToReplace)

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          // console.log("elementToReplace.innerHTML", elementToReplace.innerHTML)
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        console.log("lineItem", lineItem);
        console.log("lineItemQS", lineItem.querySelector(`[name="${name}"]`));
      })
      .catch((e) => {
        console.log("cartItems error", e);
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.themeVariables.cartStrings.error;
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      // lineItemError.classList.remove("hidden")

      lineItemError.classList.remove("hidden");

      console.log("lineitem error", lineItemError);
      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.themeVariables.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

window.customElements.define("cart-items", CartItems);

/**
 * * Cart Note
 */
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        console.log("carnote", body);
        fetch(`${themeVariables.routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        });
      }, 300)
    );
  }
}

window.customElements.define("cart-note", CartNote);

/**
 * * Cart types
 * * Includes
 * * Drawer, Notification, Page
 *
 */

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("store-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    this.addEventListener("mouseenter", this.stopTimer.bind(this));
    this.addEventListener("mouseleave", this.startTimer.bind(this));
  }

  startTimer() {
    console.log("startTimer");
    this.timeout = setTimeout(() => {
      this.close();
    }, 3000);
  }

  stopTimer() {
    console.log("stopTimer");
    clearTimeout(this.timeout);
  }

  open() {
    console.log("open");
    this.notification.classList.add("animate", "is-active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        // trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);

    // setTimeout(() => {
    //   this.close();
    // }, 3000)

    this.startTimer();
  }

  close() {
    this.notification.classList.remove("is-active");
    document.body.removeEventListener("click", this.onBodyClick);
    // removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.log("notification parsedState", parsedState.key);
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      console.log("section", section);
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    // if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      // {
      //   id: 'cart-notification-button'
      // },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

window.customElements.define("cart-notification", CartNotification);

/**
 * * Main Login
 */

class MainLogin extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.recoveryTrigger = this.querySelector("#recovery-trigger");
    this.loginTrigger = this.querySelector("#login-trigger");
    this.loginForm = this.querySelector("#main-login");
    this.recoveryForm = this.querySelector("#main-login-recovery");
    this.recoverySuccess = this.getAttribute("recovery-success");
    console.log("this.recoverySuccess", this.recoverySuccess);

    this.recoveryTrigger.addEventListener("click", () => {
      this.switchForm();
    });
    this.loginTrigger.addEventListener("click", () => {
      this.switchForm();
    });
  }

  switchForm() {
    console.log("toggle");
    if (this.recoverySuccess === "true") {
      this.loginForm.classList.toggle("hidden");
      this.recoveryForm.classList.toggle("hidden");
    } else {
      this.loginForm.classList.toggle("hidden");
      this.recoveryForm.classList.toggle("hidden");
    }
  }
}

window.customElements.define("main-login", MainLogin);

/**
 * * Modal Dialog
 */

class DrawerDialog extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    // this.closeButton = this.querySelector('button[is="close"]')
    this.closeButtons = this.querySelectorAll('button[is="close"]');
    this.modalOverlay = this.querySelector(".modal-overlay");
    this.drawer = this.querySelector("aside");
    // this.cancelButton = this.querySelector('button[type="reset"]')

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.setAttribute("role", "button");

    // close with escape
    this.details.addEventListener("keyup", (event) => {
      console.log("eventcode", event.code);
      if (event.code) event.code.toUpperCase() === "ESCAPE" && this.close();
    });

    // event listener on summary click
    this.summary.addEventListener("click", this.onSummaryClick.bind(this));

    // this.closeButton.addEventListener('click', this.close.bind(this))

    this.closeButtons.forEach((button) =>
      button.addEventListener("click", this.close.bind(this))
    );

    this.modalOverlay.addEventListener("click", this.close.bind(this));

    if (this.cancelbutton)
      this.cancelbutton.addEventListener("click", this.close.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open() {
    this.onBodyClick = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", "");
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    window.requestAnimationFrame(() => this.openAnimation());
  }

  openAnimation() {
    this.isExpanding = true;
    if (this.animation) this.animation.cancel();

    this.animation = this.drawer.animate(
      {
        transform: ["translateX(-100%)", "translateX(0)"],
      },
      {
        duration: 300,
        easing: "ease-out",
      }
    );
    // this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  close() {
    console.log("CLOSE");
    window.requestAnimationFrame(() => this.closeAnimation());
  }

  closeAnimation() {
    this.isClosing = true;

    if (this.animation) this.animation.cancel();

    this.animation = this.drawer.animate(
      {
        transform: ["translateX(0)", "translateX(-100%)"],
      },
      {
        duration: 300,
        easing: "ease-out",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!open) {
      // this.detailsContainer.removeAttribute('open')
      document.body.removeEventListener("click", this.onBodyClickEvent);
      document.body.classList.remove("overflow-hidden");
    }
  }
}

window.customElements.define("drawer-dialog", DrawerDialog);

/**
 * * Popup dialog
 */

class PopupDialog extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.closeButtons = this.querySelectorAll('button[is="close"]');
    this.modalOverlay = this.querySelector(".modal-overlay");
    this.drawer = this.querySelector("aside");

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.setAttribute("role", "button");

    // close with escape
    this.details.addEventListener("keyup", (event) => {
      console.log("eventcode", event.code);
      if (event.code) event.code.toUpperCase() === "ESCAPE" && this.close();
    });

    // event listener on summary click
    this.summary.addEventListener("click", this.onSummaryClick.bind(this));

    // this.closeButton.addEventListener('click', this.close.bind(this))

    this.closeButtons.forEach((button) =>
      button.addEventListener("click", this.close.bind(this))
    );

    this.modalOverlay.addEventListener("click", this.close.bind(this));

    if (this.cancelbutton)
      this.cancelbutton.addEventListener("click", this.close.bind(this));
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open() {
    this.onBodyClick = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", "");
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    window.requestAnimationFrame(() => this.openAnimation());
  }

  openAnimation() {
    this.isExpanding = true;
    if (this.animation) this.animation.cancel();

    this.animation = this.drawer.animate(
      {
        transform: ["translatey(20%)", "translateY(0)"],
        opacity: ["0", "100"],
      },
      {
        duration: 300,
        easing: "ease-out",
      }
    );
    // this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  close() {
    console.log("CLOSE");
    window.requestAnimationFrame(() => this.closeAnimation());
  }

  closeAnimation() {
    this.isClosing = true;

    if (this.animation) this.animation.cancel();

    this.animation = this.drawer.animate(
      {
        // transform: ['translateY(0)', 'translateY(-100%)'],
        opacity: ["100", "0"],
      },
      {
        duration: 300,
        easing: "ease-out",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!open) {
      // this.detailsContainer.removeAttribute('open')
      document.body.removeEventListener("click", this.onBodyClickEvent);
      document.body.classList.remove("overflow-hidden");
    }
  }
}

window.customElements.define("popup-dialog", PopupDialog);

/**
 * * Account Addresses
 */
class AddAddressDrawer extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.closeButton = this.querySelector('button[type="button"]');
    this.modalOverlay = this.querySelector(".modal-overlay");
    this.drawerContent = this.querySelector("#drawer-content");

    // animations
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );

    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );

    this.closeButton.addEventListener("click", this.close.bind(this));
    this.modalOverlay.addEventListener("click", this.close.bind(this));

    this.summaryToggle.setAttribute("role", "button");
  }

  onSummaryClick(event) {
    event.preventDefault();
    // const isOpen = detailsElement.hasAttribute('open');

    // if (isOpen) event.preventDefault();
    // isOpen ? this.close(event, summaryElement) : this.open(summaryElement)

    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    this.onBodyClick = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", "");
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    window.requestAnimationFrame(() => this.openAnimation());
    // trapFocus(
    //   this.detailsContainer.querySelector('[tabindex="-1"]'),
    //   this.detailsContainer.querySelector('input:not([type="hidden"])')
    // );
  }

  openAnimation() {
    this.isExpanding = true;

    if (this.animation) this.animation.cancel();

    this.animation = this.drawerContent.animate(
      {
        transform: ["translateX(-100%)", "translateX(0)"],
      },
      {
        duration: 300,
        easing: "ease-in-out",
      }
    );
    // this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  close(focusToggle = true) {
    // this.detailsContainer.removeAttribute('open')
    // document.body.removeEventListener('click', this.onBodyClickEvent)
    // document.body.classList.remove('overflow-hidden')

    window.requestAnimationFrame(() => this.closeAnimation());
  }

  closeAnimation() {
    this.isClosing = true;

    // if (this.animation) this.animation.cancel()

    this.animation = this.drawerContent.animate(
      {
        transform: ["translateX(0)", "translateX(-100%)"],
      },
      {
        duration: 300,
        easing: "ease-out",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  onAnimationFinish(open) {
    this.detailsContainer.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!open) {
      // this.detailsContainer.removeAttribute('open')
      document.body.removeEventListener("click", this.onBodyClickEvent);
      document.body.classList.remove("overflow-hidden");
    }
  }
}

window.customElements.define("add-address", AddAddressDrawer);

/**
 * * Product Media
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.productItems = Array.from(this.querySelectorAll("[reveal]"));
    var slider = new KeenSlider(
      "#Product-media-container",
      {
        loop: true,
        created: () => {
          console.log("created");
        },
        breakpoints: {
          "(min-width: 1024px)": {
            disabled: true,
          },
        },
      },
      [navigation]
    );

    this.productItems.map((item, index) => {
      observer.observe(item);
    });
  }
}

window.customElements.define("product-media", ProductMedia);

/***
 * * Product Grid
 */

class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.productItems = Array.from(this.querySelectorAll("[reveal]"));

    // this.productItems.map((item) =>  item.style.opacity = 0 )

    this.productItems.map((item, index) => {
      observer.observe(item);
    });
    // this.animation();
  }

  // animation() {
  //   this.animation = this.productItems.map((item, index) => {
  //     item.animate(
  //       {
  //         opacity: [0, 1],
  //         // transform: ["translateY(10%)", "translateY(0)"],
  //         transform: ["scale(1.1)", "scale(1)"]
  //       },
  //       {
  //         duration: 600,
  //         easing: "ease-out",
  //         delay: 100 * index - Math.min(3 * index * index, 100 * index)
  //       }
  //     );
  //   });
  // }
}

window.customElements.define("product-grid", ProductGrid);

class UICarousel extends HTMLElement {
  constructor() {
    super();
    this.validPaginationTypes = [
      "progressbar",
      "bullets",
      "fraction",
      "custom",
    ];
    this.defaultConfig = {
      loop: false,
      slidesPerView: this.dataset.slidesPerView || 1,
      spaceBetween: 30,
    };
  }

  connectedCallback() {
    this.initializeSwiper(this.getMergedConfig());
  }

  getMergedConfig() {
    const config = {
      ...this.defaultConfig,
      ...this.getNavigationConfig(),
      ...this.getPaginationConfig(),
      ...this.getCustomConfig(),
    };

    return config;
  }

  getNavigationConfig() {
    // Simple presence check for the attribute
    if (this.hasAttribute("data-navigation")) {
      return {
        navigation: {
          nextEl: ".ui-carousel-next",
          prevEl: ".ui-carousel-prev",
        },
      };
    }
    return {};
  }

  getPaginationConfig() {
    const paginationType = this.dataset.pagination;

    if (!paginationType) return {};

    if (!this.validPaginationTypes.includes(paginationType)) {
      console.warn(
        `Invalid pagination type "${paginationType}". Using default "bullets" type. ` +
          `Valid types are: ${this.validPaginationTypes.join(", ")}`
      );
      return {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
      };
    }

    return {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: paginationType,
      },
    };
  }

  getCustomConfig() {
    // Method to be overridden by child classes for custom configuration
    return {};
  }

  initializeSwiper(config) {
    this.swiper = new Swiper(this, config);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define("ui-carousel", UICarousel);

class ProjectsCarousel extends UICarousel {
  getCustomConfig() {
    return {
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    };
  }
}

window.customElements.define("projects-carousel", ProjectsCarousel);

class InViewObserver extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.threshold = 0; // Default threshold
    this.once = true; // Default to once
    this.rootMargin = "0px 0px -50px 0px"; // Default margin
    this.selector = "[data-in-view]"; // Default selector
  }

  // The rest of the code remains the same
  connectedCallback() {
    this.setupObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (this.observer) {
      this.observer.disconnect();
      this.setupObserver();
    }
  }

  setupObserver() {
    const options = {
      rootMargin: this.rootMargin,
      threshold: parseFloat(this.threshold),
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const target = entry.target;

        if (entry.isIntersecting) {
          // Add class to the target element
          target.classList.add("in-view");

          // Dispatch event on the target
          target.dispatchEvent(
            new CustomEvent("in-view", {
              bubbles: true,
              detail: { entry },
            })
          );

          if (this.once) {
            observer.unobserve(target);
          }
        } else {
          // Remove class if not using 'once'
          if (!this.once) {
            target.classList.remove("in-view");
          }

          // Dispatch event on the target
          target.dispatchEvent(
            new CustomEvent("out-view", {
              bubbles: true,
              detail: { entry },
            })
          );
        }
      });
    }, options);

    // Select elements to observe
    const elementsToObserve = document.querySelectorAll(this.selector);
    elementsToObserve.forEach((element) => {
      this.observer.observe(element);
    });
  }
}

window.customElements.define("in-view-observer", InViewObserver);

// class DetailsModal extends HTMLElement {
//   constructor() {
//     super();
//     this.detailsContainer = this.querySelector("details");
//     this.summaryToggle = this.querySelector("summary");
//     this.modalContainer = this.querySelector("[data-modal-container]");
//     this.searchPanel = this.querySelector("[data-search-panel]");
//     this.modalOverlay = this.querySelector("[data-modal-overlay]");
//     this.closeButton = this.querySelector("[data-close-button]");
//     this.searchIcon = this.querySelector(".search-icon");
//     this.closeIcon = this.querySelector(".close-icon");
//     this.searchInput = this.querySelector('input[type="search"]');
//     this.resetButton = this.querySelector('button[type="reset"]');
//     this.predictiveSearchContainer = this.querySelector(".predictive-search");

//     if (!this.detailsContainer || !this.summaryToggle) return;

//     // Event listeners
//     this.detailsContainer.addEventListener(
//       "keyup",
//       (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
//     );
//     this.summaryToggle.addEventListener(
//       "click",
//       this.onSummaryClick.bind(this)
//     );
//     if (this.closeButton) {
//       this.closeButton.addEventListener("click", this.close.bind(this));
//     }
//     if (this.modalOverlay) {
//       this.modalOverlay.addEventListener("click", this.close.bind(this));
//     }

//     // Handle search input events
//     if (this.searchInput) {
//       this.searchInput.addEventListener("input", this.onInputChange.bind(this));

//       // Add reset event listener to the reset button
//       if (this.resetButton) {
//         this.resetButton.addEventListener(
//           "click",
//           this.onResetClick.bind(this)
//         );
//       }
//     }

//     // Listen for predictive search results
//     this.setupPredictiveSearchObserver();

//     this.summaryToggle.setAttribute("role", "button");
//   }

//   setupPredictiveSearchObserver() {
//     // Create a MutationObserver to detect when search results are added
//     this.observer = new MutationObserver((mutations) => {
//       mutations.forEach((mutation) => {
//         if (
//           mutation.type === "childList" &&
//           this.predictiveSearchContainer.querySelector(
//             "#predictive-search-results"
//           )
//         ) {
//           // Only expand search results if there's actually text in the input
//           if (this.searchInput && this.searchInput.value.length > 0) {
//             this.expandSearchResults();
//           }
//         }
//       });
//     });

//     // Start observing the predictive search container
//     this.observer.observe(this.predictiveSearchContainer, {
//       childList: true,
//       subtree: true,
//     });
//   }

//   onInputChange() {
//     // Toggle reset button visibility
//     if (this.resetButton) {
//       this.resetButton.classList.toggle("hidden", !this.searchInput.value);
//     }

//     // Handle search results container height based on input value
//     if (this.predictiveSearchContainer) {
//       if (this.searchInput.value.length > 0) {
//         this.expandSearchResults();
//       } else {
//         this.collapseSearchResults();
//       }
//     }
//   }

//   // Handle reset button click
//   onResetClick() {
//     // Make sure the search results are collapsed when reset is clicked
//     setTimeout(() => {
//       this.collapseSearchResults();
//     }, 10);
//   }

//   expandSearchResults() {
//     // Animate the search results container to show
//     if (this.predictiveSearchContainer) {
//       this.predictiveSearchContainer.style.maxHeight = "80vh";
//       this.predictiveSearchContainer.style.paddingTop = "1rem";
//       this.predictiveSearchContainer.style.paddingBottom = "1rem";
//       this.predictiveSearchContainer.style.opacity = "1";
//     }
//   }

//   collapseSearchResults() {
//     // Animate the search results container to hide
//     if (this.predictiveSearchContainer) {
//       this.predictiveSearchContainer.style.maxHeight = "0";
//       this.predictiveSearchContainer.style.paddingTop = "0";
//       this.predictiveSearchContainer.style.paddingBottom = "0";
//       this.predictiveSearchContainer.style.opacity = "0";
//     }
//   }

//   isOpen() {
//     return this.detailsContainer.hasAttribute("open");
//   }

//   onSummaryClick(event) {
//     event.preventDefault();
//     event.target.closest("details").hasAttribute("open")
//       ? this.close()
//       : this.open(event);
//   }

//   onBodyClick(event) {
//     if (
//       !this.contains(event.target) ||
//       event.target.classList.contains("modal-overlay")
//     ) {
//       this.close(false);
//     }
//   }

//   open(event) {
//     this.onBodyClickEvent =
//       this.onBodyClickEvent || this.onBodyClick.bind(this);

//     // Set open attribute
//     this.detailsContainer.setAttribute("open", true);

//     // Show modal container
//     this.modalContainer.classList.remove("invisible");

//     // Animate opacity
//     setTimeout(() => {
//       this.modalContainer.classList.remove("opacity-0");
//       this.modalContainer.classList.add("opacity-100");
//     }, 10);

//     // Animate search panel
//     setTimeout(() => {
//       this.searchPanel.classList.remove("-translate-y-full");
//       this.searchPanel.classList.add("translate-y-0");
//     }, 50);

//     // Toggle icons
//     if (this.searchIcon && this.closeIcon) {
//       this.searchIcon.classList.add("hidden");
//       this.closeIcon.classList.remove("hidden");
//       this.closeIcon.classList.add("inline-flex");
//     }

//     // Body setup
//     document.body.addEventListener("click", this.onBodyClickEvent);
//     document.body.classList.add("overflow-hidden");

//     // Focus input
//     setTimeout(() => {
//       if (this.searchInput) this.searchInput.focus();
//     }, 300);

//     // Initialize search results container state
//     if (this.predictiveSearchContainer) {
//       if (this.searchInput && this.searchInput.value.length > 0) {
//         this.expandSearchResults();
//       } else {
//         this.collapseSearchResults();
//       }
//     }
//   }

//   close(focusToggle = true) {
//     if (!this.isOpen()) return;

//     // Collapse search results first
//     this.collapseSearchResults();

//     // Animate out
//     if (this.searchPanel) {
//       this.searchPanel.classList.remove("translate-y-0");
//       this.searchPanel.classList.add("-translate-y-full");
//     }

//     if (this.modalContainer) {
//       this.modalContainer.classList.remove("opacity-100");
//       this.modalContainer.classList.add("opacity-0");
//     }

//     // Toggle icons
//     if (this.searchIcon && this.closeIcon) {
//       this.closeIcon.classList.add("hidden");
//       this.closeIcon.classList.remove("inline-flex");
//       this.searchIcon.classList.remove("hidden");
//     }

//     // Cleanup
//     document.body.removeEventListener("click", this.onBodyClickEvent);
//     document.body.classList.remove("overflow-hidden");

//     // Allow animation to complete before closing
//     setTimeout(() => {
//       this.detailsContainer.removeAttribute("open");
//       if (this.modalContainer) {
//         this.modalContainer.classList.add("invisible");
//       }

//       // Return focus if needed
//       if (focusToggle && this.summaryToggle) {
//         this.summaryToggle.focus();
//       }
//     }, 300);
//   }
// }

// customElements.define("details-modal", DetailsModal);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.modalContainer = this.querySelector("[data-modal-container]");
    this.searchPanel = this.querySelector("[data-search-panel]");
    this.modalOverlay = this.querySelector("[data-modal-overlay]");
    this.closeButton = this.querySelector("[data-close-button]");
    this.searchIcon = this.querySelector(".search-icon");
    this.closeIcon = this.querySelector(".close-icon");
    this.searchInput = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.predictiveSearchContainer = this.querySelector(".predictive-search");

    if (!this.detailsContainer || !this.summaryToggle) return;

    // Event listeners
    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.close.bind(this));
    }
    if (this.modalOverlay) {
      this.modalOverlay.addEventListener("click", this.close.bind(this));
    }

    // Handle search input events
    if (this.searchInput) {
      this.searchInput.addEventListener("input", this.onInputChange.bind(this));

      // Add reset event listener to the reset button
      if (this.resetButton) {
        this.resetButton.addEventListener(
          "click",
          this.onResetClick.bind(this)
        );
      }
    }

    // Listen for predictive search results
    this.setupPredictiveSearchObserver();

    this.summaryToggle.setAttribute("role", "button");
  }

  setupPredictiveSearchObserver() {
    // Create a MutationObserver to detect when search results are added or changed
    this.observer = new MutationObserver((mutations) => {
      // Only proceed if there's text in the input
      if (this.searchInput && this.searchInput.value.length > 0) {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "childList" &&
            this.predictiveSearchContainer.querySelector(
              "#predictive-search-results"
            )
          ) {
            this.expandSearchResults();
          }
        });
      }
    });

    // Start observing the predictive search container
    this.observer.observe(this.predictiveSearchContainer, {
      childList: true,
      subtree: true,
    });
  }

  onInputChange() {
    // Toggle reset button visibility
    if (this.resetButton) {
      this.resetButton.classList.toggle("hidden", !this.searchInput.value);
    }

    // Handle search results container height based on input value
    if (this.predictiveSearchContainer) {
      if (this.searchInput.value.length > 0) {
        this.expandSearchResults();
      } else {
        this.collapseSearchResults();
      }
    }
  }

  // Handle reset button click
  onResetClick() {
    // Make sure the search results are collapsed when reset is clicked
    setTimeout(() => {
      this.collapseSearchResults();
    }, 10);
  }

  expandSearchResults() {
    // Animate the search results container to show with content-based height
    if (this.predictiveSearchContainer) {
      // First set it to a very small non-zero height so we can measure content
      this.predictiveSearchContainer.style.maxHeight = "1px";
      this.predictiveSearchContainer.style.paddingTop = "1rem";
      this.predictiveSearchContainer.style.paddingBottom = "1rem";
      this.predictiveSearchContainer.style.opacity = "1";

      // Use setTimeout to ensure DOM has updated before measuring
      setTimeout(() => {
        // Get the scroll height (full content height)
        const contentHeight = this.predictiveSearchContainer.scrollHeight;
        // Set the max height to match the content (with reasonable max limit)
        this.predictiveSearchContainer.style.maxHeight =
          Math.min(contentHeight, window.innerHeight * 0.8) + "px";
      }, 10);
    }
  }

  collapseSearchResults() {
    // Animate the search results container to hide
    if (this.predictiveSearchContainer) {
      this.predictiveSearchContainer.style.maxHeight = "0";
      this.predictiveSearchContainer.style.paddingTop = "0";
      this.predictiveSearchContainer.style.paddingBottom = "0";
      this.predictiveSearchContainer.style.opacity = "0";
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    ) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);

    // Set open attribute
    this.detailsContainer.setAttribute("open", true);

    // Show modal container
    this.modalContainer.classList.remove("invisible");

    // Animate opacity
    setTimeout(() => {
      this.modalContainer.classList.remove("opacity-0");
      this.modalContainer.classList.add("opacity-100");
    }, 10);

    // Animate search panel
    setTimeout(() => {
      this.searchPanel.classList.remove("-translate-y-full");
      this.searchPanel.classList.add("translate-y-0");
    }, 50);

    // Toggle icons
    if (this.searchIcon && this.closeIcon) {
      this.searchIcon.classList.add("hidden");
      this.closeIcon.classList.remove("hidden");
      this.closeIcon.classList.add("inline-flex");
    }

    // Body setup
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    // Focus input
    setTimeout(() => {
      if (this.searchInput) this.searchInput.focus();
    }, 300);

    // Initialize search results container state
    if (this.predictiveSearchContainer) {
      if (this.searchInput && this.searchInput.value.length > 0) {
        this.expandSearchResults();
      } else {
        this.collapseSearchResults();
      }
    }
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;

    // Collapse search results first
    this.collapseSearchResults();

    // Animate out
    if (this.searchPanel) {
      this.searchPanel.classList.remove("translate-y-0");
      this.searchPanel.classList.add("-translate-y-full");
    }

    if (this.modalContainer) {
      this.modalContainer.classList.remove("opacity-100");
      this.modalContainer.classList.add("opacity-0");
    }

    // Toggle icons
    if (this.searchIcon && this.closeIcon) {
      this.closeIcon.classList.add("hidden");
      this.closeIcon.classList.remove("inline-flex");
      this.searchIcon.classList.remove("hidden");
    }

    // Cleanup
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");

    // Allow animation to complete before closing
    setTimeout(() => {
      this.detailsContainer.removeAttribute("open");
      if (this.modalContainer) {
        this.modalContainer.classList.add("invisible");
      }

      // Return focus if needed
      if (focusToggle && this.summaryToggle) {
        this.summaryToggle.focus();
      }
    }, 300);
  }
}

customElements.define("details-modal", DetailsModal);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  onChange() {
    this.toggleResetButton();
  }
  ome;

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define("search-form", SearchForm);

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector(
      "[data-predictive-search]"
    );
    this.allPredictiveSearchInstances =
      document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`,
      {
        signal: this.abortController.signal,
      }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]")
        .textContent
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document.querySelector(".section-header")?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}

customElements.define("predictive-search", PredictiveSearch);

class NewsletterPopupTrigger extends HTMLElement {
  constructor() {
    super();
    this.modal = document.querySelector("newsletter-popup-modal");

    // Bind methods to preserve 'this' context
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  connectedCallback() {
    // Make the entire element focusable and clickable
    this.setAttribute("tabindex", "0");

    // Add keyboard support (Enter and Space key)
    this.addEventListener("keydown", this.handleKeyDown);

    // Add click event to the entire element
    this.addEventListener("click", this.handleClick);

    console.log("Newsletter trigger connected, modal:", this.modal);
  }

  disconnectedCallback() {
    // Remove event listeners to prevent memory leaks
    this.removeEventListener("keydown", this.handleKeyDown);
    this.removeEventListener("click", this.handleClick);
  }

  handleKeyDown(e) {
    // Trigger on Enter or Space key
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.triggerPopup();
    }
  }

  handleClick(e) {
    // Allow clicks on the element or any of its children
    e.preventDefault();
    this.triggerPopup();
  }

  triggerPopup() {
    if (this.modal) {
      console.log("Triggering popup");
      this.modal.toggleOpen();
    } else {
      console.error("Newsletter modal not found");
    }
  }
}

window.customElements.define(
  "newsletter-popup-trigger",
  NewsletterPopupTrigger
);

class NewsletterPopupModal extends HTMLElement {
  static get observedAttributes() {
    return ["delay", "cookie-duration"];
  }

  constructor() {
    super();
    this.isOpen = false;
    this.delay = 2000;
    this.cookieDuration = 7;
    this.cookieName = "newsletter_popup_shown";
    this.hasShownAutomatically = false;
    this.isThemeEditor = window.Shopify && window.Shopify.designMode;

    // Bind methods to preserve context
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleSectionSelect = this.handleSectionSelect.bind(this);
    this.handleSectionDeselect = this.handleSectionDeselect.bind(this);

    // Make sure the initial state is set correctly
    this.setAttribute("aria-hidden", "true");
    this.classList.add("hidden");

    console.log("Newsletter modal initialized");
  }

  // Dawn's getFocusableElements method
  getFocusableElements() {
    return Array.from(
      this.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  trapFocus() {
    // Find the email input
    const emailInput = this.querySelector('input[type="email"]');
    const elements = this.getFocusableElements();

    if (!elements.length) {
      console.warn("No focusable elements found in modal");
      return;
    }

    const first = elements[0];
    const last = elements[elements.length - 1];

    // Focus the email input if it exists, otherwise focus the first element
    if (emailInput) {
      emailInput.focus();
    } else if (first) {
      first.focus();
    }

    // Remove any existing trap focus handlers
    this.removeTrapFocus();

    // Create a new handler
    this.trapFocusHandlers = {};
    this.trapFocusHandlers.keydown = (event) => {
      if (event.key !== "Tab") return;

      // If shift + tab on first element, go to last element
      if (
        event.shiftKey &&
        (document.activeElement === first ||
          !this.contains(document.activeElement))
      ) {
        event.preventDefault();
        last.focus();
      }
      // If tab on last element, go to first element
      else if (
        !event.shiftKey &&
        (document.activeElement === last ||
          !this.contains(document.activeElement))
      ) {
        event.preventDefault();
        first.focus();
      }
    };

    // Add the handler
    document.addEventListener("keydown", this.trapFocusHandlers.keydown);
  }

  // Remove trap focus handlers
  removeTrapFocus() {
    if (this.trapFocusHandlers && this.trapFocusHandlers.keydown) {
      document.removeEventListener("keydown", this.trapFocusHandlers.keydown);
    }
  }

  connectedCallback() {
    console.log("Newsletter modal connected, delay:", this.delay);

    // Add event listeners to close buttons
    this.closeButtons = this.querySelectorAll('[data-js="close"]');
    this.closeButtons.forEach((button) => {
      button.addEventListener("click", this.handleCloseClick);
    });

    // Setup theme editor specific events if in theme editor
    if (this.isThemeEditor) {
      document.addEventListener(
        "shopify:section:select",
        this.handleSectionSelect
      );
      document.addEventListener(
        "shopify:section:deselect",
        this.handleSectionDeselect
      );
      console.log("Theme editor mode enabled");
      return; // Exit early to prevent auto-show logic
    }

    // Auto-show logic only runs if NOT in theme editor
    if (!this.hasSeenPopup()) {
      console.log(`Will show popup in ${this.delay}ms`);
      setTimeout(() => {
        this.showIfEligible();
      }, this.delay);
    } else {
      console.log("User has already seen popup");
    }
  }

  disconnectedCallback() {
    this.removeTrapFocus();
    this.closeButtons.forEach((button) => {
      button.removeEventListener("click", this.handleCloseClick);
    });

    if (this.isThemeEditor) {
      document.removeEventListener(
        "shopify:section:select",
        this.handleSectionSelect
      );
      document.removeEventListener(
        "shopify:section:deselect",
        this.handleSectionDeselect
      );
    }
  }

  handleSectionSelect(event) {
    // Get the section ID from the event target
    const sectionId = event.detail.sectionId;

    // Get our newsletter popup's section ID
    const popupSectionId = this.closest(".shopify-section")?.id;

    // Only open if this specific section was selected
    if (sectionId === popupSectionId) {
      this.toggleOpen(false);
    }
  }

  handleSectionDeselect(event) {
    // Get the section ID from the event target
    const sectionId = event.detail.sectionId;

    // Get our newsletter popup's section ID
    const popupSectionId = this.closest(".shopify-section")?.id;

    // Only close if this specific section was deselected
    if (sectionId === popupSectionId) {
      if (this.isOpen) {
        this.toggleOpen(false);
      }
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "delay") {
      this.delay = parseInt(newValue, 10) || 2000;
      console.log("Delay updated:", this.delay);
    }
    if (name === "cookie-duration") {
      this.cookieDuration = parseInt(newValue, 10) || 7;
      console.log("Cookie duration updated:", this.cookieDuration);
    }
  }

  handleCloseClick(e) {
    e.preventDefault();
    this.toggleOpen();
  }

  toggleOpen(isAutomatic = false) {
    console.log("Toggle open called, isAutomatic:", isAutomatic);

    // Only check cookie for automatic opening and when not in theme editor
    if (isAutomatic && !this.isThemeEditor && this.hasSeenPopup()) {
      console.log("Skipping automatic open - user has seen popup");
      return;
    }

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      console.log("Opening popup");
      this.removeAttribute("aria-hidden");
      this.classList.remove("hidden");
      document.body.style.overflow = "hidden";

      document.addEventListener("keydown", this.handleEscapeKey);
      document.addEventListener("click", this.handleClickOutside);

      // Use setTimeout and requestAnimationFrame to ensure the DOM is updated
      setTimeout(() => {
        requestAnimationFrame(() => {
          this.classList.add("newsletter-modal--open");
          this.trapFocus();
        });
      }, 10);

      // Only set cookie if not in theme editor
      if (!this.isThemeEditor) {
        this.setPopupCookie();
        this.hasShownAutomatically = true;
      }
    } else {
      console.log("Closing popup");
      this.classList.remove("newsletter-modal--open");

      document.removeEventListener("keydown", this.handleEscapeKey);
      document.removeEventListener("click", this.handleClickOutside);

      this.removeTrapFocus();

      // Allow time for close animation
      setTimeout(() => {
        this.setAttribute("aria-hidden", "true");
        this.classList.add("hidden");
        document.body.style.overflow = "";

        const triggerElement = document.querySelector(
          "newsletter-popup-trigger"
        );
        if (triggerElement) {
          triggerElement.focus();
        }
      }, 300);
    }
  }

  showIfEligible() {
    console.log("Checking if eligible to show popup");
    this.toggleOpen(true); // Pass true for automatic opening
  }

  hasSeenPopup() {
    const hasCookie = document.cookie.split(";").some((cookie) => {
      return cookie.trim().startsWith(this.cookieName + "=");
    });
    console.log("Has seen popup:", hasCookie);
    return hasCookie;
  }

  setPopupCookie() {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + this.cookieDuration);
    document.cookie = `${
      this.cookieName
    }=true; expires=${expirationDate.toUTCString()}; path=/`;
    console.log("Cookie set, expires:", expirationDate.toUTCString());
  }

  handleEscapeKey(e) {
    if (e.key === "Escape") {
      this.toggleOpen();
    }
  }

  handleClickOutside(e) {
    if (e.target === this) {
      this.toggleOpen();
    }
  }
}

window.customElements.define("newsletter-popup-modal", NewsletterPopupModal);
